module.exports = __webpack_public_path__ + "static/media/konstifiket.d00284ad.png";